import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router-dom';

import { Flex } from '../../../components/common/atom/Layout';
import { Text } from '../../../components/common/atom/Text';
import { BulletList } from '../../../components/common/molecules/BulletList';

import Loading from '../../../components/common/organism/Loading';
import { getOptionGroup } from '../../Sales/Item/BabyfaceAPI';

import ThemeStyle from '../../../lib/style/ThemeStyle';

const OrderOptionsInfo = () => {
  const history = useHistory();

  const [isLoading, setIsLoading] = useState(false);
  const [selectedOptions, setSelectedOptions] = useState(
    INITIAL_STATE_SELECTED_OPTIONS,
  );

  useEffect(() => {
    setIsLoading(true);
    getOptionGroup({ id: sessionStorage.itemId })
      .then((response) => {
        const setOptions = ({ name }) => {
          const [optionsFilteredByRequired] = response.filter(
            (el) => el.name === name,
          );

          return {
            title: optionsFilteredByRequired.name,
            option: optionsFilteredByRequired.options
              .filter((option) => sessionStorage.optionIds.includes(option.id))
              .map((option) => ({
                id: option.id,
                content: option.description.split(';'),
                name: option.name,
              })),
          };
        };

        setSelectedOptions({
          defaultOption: setOptions({ name: "필수옵션" }),
          printOption: setOptions({ name: "인화옵션" }),
          additionalOptions: setOptions({ name: "추가옵션" }),
        });
      })
      .catch(() => {
        history.goBack();
      })
      .finally(() => {
        setIsLoading(false);
      });
  }, []);

  const { defaultOption, printOption, additionalOptions } = selectedOptions;

  return isLoading ? (
    <Loading padding="1.25rem" onlyLoader />
  ) : (
    <Flex
      column
      width="100%"
      style={{
        borderRadius: '6px',
        border: `solid 1px ${ThemeStyle.color.pinkishGrey}`,
      }}
    >
      <Title title={defaultOption.title} first />
      <OptionList
        title={defaultOption.option[0].name}
        contents={defaultOption.option[0].content}
      />
      {printOption.option.length > 0 &&
        <>
          <Title title={printOption.title} />
          <OptionList
            title={printOption.option[0].name}
            contents={printOption.option[0].content}
          />
        </>
      }
      {additionalOptions.option.length > 0 && (
        <>
          <Title title={additionalOptions.title} />
          {additionalOptions.option.map((item) => (
            <OptionList
              key={item.id}
              title={item.name}
              contents={item.content}
            />
          ))}
        </>
      )}
    </Flex>
  );
};

export default OrderOptionsInfo;

const INITIAL_STATE_SELECTED_OPTIONS = {
  defaultOption: { title: '', option: [{ id: 0, content: [], name: '' }] },
  printOption: { title: '', option: [{ id: 0, content: [], name: '' }] },
  additionalOptions: {
    title: '',
    option: [{ id: 0, content: [], name: '' }],
  },
};

const Title = ({ title, first }) => (
  <Flex
    column
    width="100%"
    padding="0.5rem 1rem"
    alignItems="flex-start"
    style={{
      backgroundColor: ThemeStyle.background.grey,
      borderBottom: `solid 1px ${ThemeStyle.color.pinkishGrey}`,
      borderTop: first ? 'none' : `solid 1px ${ThemeStyle.color.pinkishGrey}`,
      borderRadius: first ? '6px 6px 0 0' : 'none',
    }}
  >
    <Text size={12} weight="medium">
      {title}
    </Text>
  </Flex>
);

const OptionList = ({ title, contents }) => {
  return (
    <Flex column padding="0.625rem 1rem 0" alignItems="flex-start" width="100%">
      <Flex column width="100%" alignItems="flex-start">
        <Text size={12} weight="medium">
          {title}
        </Text>
        <BulletList
          contents={contents}
          ulStyle={{ marginBlockStart: '0.5rem' }}
          liStyle={{ fontSize: '0.625rem' }}
        />
      </Flex>
    </Flex>
  );
};
